import * as React from 'react';
import {WrappedFieldProps} from "redux-form";
import FormGroupTextarea from "./form_group_textarea";
import {RefObject} from "react";

interface IProps {
    placeholder: string;
    rows?: number;
    maxRows?: number;
    type: string;
    name: string;
    label: string;
    textareaRef?: RefObject<HTMLTextAreaElement>;
    require?: boolean;
}

const FormGroupTextareaConnectRf: React.FC<IProps & WrappedFieldProps> = (props) => {

    const {placeholder, type, name, rows, maxRows, label, meta, children, input,
        textareaRef, require} = props;
    const hasError = !!meta.error && !!meta.touched;

    return (
        <FormGroupTextarea
            placeholder={placeholder}
            type={type}
            name={name}
            rows={rows}
            maxRows={maxRows}
            label={label}
            children={children}
            hasError={hasError}
            textareaRef={textareaRef}
            input={input}
            errorText={meta.error}
            require={require}
        />
    )
};

export default (FormGroupTextareaConnectRf);



// WEBPACK FOOTER //
// ./src/presentation/common/molecular/form_group/form_group_textarea_connect_rf.tsx